export const PaymentActionTypes = {
  SET_PAYMENT_SESSION: "@@payment/SET_PAYMENT_SESSION",
  SET_PAYMENT_ERROR: "@@payment/SET_PAYMENT_ERROR",
  SET_PAYMENT_ERROR_RESULT: "@@payment/SET_PAYMENT_ERROR_RESULT",
  SET_SWISH_PAYMENT_RESPONSE_STATUS:
    "@@payment/SET_SWISH_PAYMENT_RESPONSE_STATUS",
  SET_SELECTED_PAYMENT_OPTION: "@@payment/SET_SELECTED_PAYMENT_OPTION",
};
